import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './i18n';

try {
  const rootElement = document.getElementById('root');

  if (!rootElement) {
    throw new Error('Root element not found');
  }

  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
} catch (error) {
  console.error('Failed to render app:', error);

  const rootElement = document.getElementById('root');
  if (rootElement) {
    rootElement.innerHTML = `
      <div style="min-height: 100vh; display: flex; align-items: center; justify-content: center; background-color: #f9fafb; padding: 1rem; font-family: system-ui, -apple-system, sans-serif;">
        <div style="max-width: 28rem; width: 100%; background-color: white; border-radius: 0.5rem; box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1); padding: 2rem; text-align: center;">
          <div style="margin: 0 auto; display: flex; align-items: center; justify-content: center; height: 3rem; width: 3rem; border-radius: 50%; background-color: #fee2e2; margin-bottom: 1rem;">
            <svg style="height: 1.5rem; width: 1.5rem; color: #dc2626;" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h2 style="font-size: 1.5rem; font-weight: 700; color: #111827; margin-bottom: 1rem;">
            Erreur de chargement
          </h2>
          <p style="color: #6b7280; margin-bottom: 1.5rem;">
            Impossible de charger l'application. Veuillez recharger la page ou réessayer plus tard.
          </p>
          <button
            onclick="window.location.reload()"
            style="width: 100%; background-color: #18994E; color: white; padding: 0.75rem 1.5rem; border-radius: 0.5rem; border: none; cursor: pointer; font-weight: 500; font-size: 1rem;"
            onmouseover="this.style.backgroundColor='#147a3f'"
            onmouseout="this.style.backgroundColor='#18994E'"
          >
            Recharger la page
          </button>
        </div>
      </div>
    `;
  }
}